$(document).ready(function() {
 	if( Modernizr.inputtypes.date) {
		$('#birthdate-mobile').show();
		$('#birthdate-fallback').remove();
	}
	$('#birthdate-fallback select').change(function(){
		var year = $('#birthdate-fallback select[name=Date_Year]').val();
		var month = $('#birthdate-fallback select[name=Date_Month]').val();
		var day = $('#birthdate-fallback select[name=Date_Day]').val();
		if(day < 10) day = '0'+day;
		
		var date = year+'-'+month+'-'+day; 
		$('#birthdate-picker').val(date);
	});
});



$(document).ready(function() {
 	if( Modernizr.inputtypes.date) {
		$('#birthdate-mobile').show();
		$('#birthdate-fallback').remove();
	}
	$('#birthdate-fallback select').change(function(){
		var year = $('#birthdate-fallback select[name=Date_Year]').val();
		var month = $('#birthdate-fallback select[name=Date_Month]').val();
		var day = $('#birthdate-fallback select[name=Date_Day]').val();
		if(day < 10) day = '0'+day;
		
		var date = year+'-'+month+'-'+day; 
		$('#birthdate-picker').val(date);
	});
});



$(function () {
    $('.header-login-form-toggle').on('click', function() {
        $('.header-login-form').toggleClass('open');
    });

    $('.submenu--shops a').on('click', function() {
        $(this).closest('.submenu--shops').children('ul').toggleClass('open');
        $(this).find('.glyphicon').toggleClass('glyphicon-triangle-top').toggleClass('glyphicon-triangle-bottom');
    })

    $('.collapse').on('show.bs.collapse', function () {
        $(this).prev().find('.glyphicon').removeClass('glyphicon-triangle-bottom').addClass('glyphicon-triangle-top');
    });

    $('.collapse').on('hide.bs.collapse', function () {
        $(this).prev().find('.glyphicon').removeClass('glyphicon-triangle-top').addClass('glyphicon-triangle-bottom');
    });
});
